<template>
  <PuSkeleton :loading="isLoading" :count="10" width='100%'>
      <b-tabs class="block__tabsSidebar" v-if="currentType != 'CONFIG_AGENT' && currentType != 'CONFIG_COLLABORATEUR'">
          <div class="toggle" v-if="currentType != 'CONFIG_NATIONAL'">
              <span>Tous</span>
              <ion-toggle
                      @ionChange="fetchAll($event)"
                      mode="ios" >
              </ion-toggle>
          </div>
              <b-tab v-for="(value,index) in theList" :key="index" :title="value.title">
                  <div class="entete">
                      <div class="title">{{value.subtitle}}</div>
                  </div>
                  <b-list-group>
                      <PuSkeleton :loading="isListLoading" :count="5" width='100%'>
                          <b-list-group-item v-for="(subList,f) in value.ranking" :key="f">
                              <div class="bt-list left">
                                  <div class="target" :class="getTheIncrease(subList.rank,subList.previousRank)">
                                      {{getTheIncrease(subList.rank,subList.previousRank)!= 'equal' ? getTheEvolution(subList.rank,subList.previousRank):''}}
                                  </div>
                                  <div class="ranking">{{subList.rank}}</div>
                                  <div class="fullname">{{subList.name}}</div>
                              </div>
                              <div class="right">
                                  {{Math.round(subList.points).toLocaleString()}}
                              </div>
                          </b-list-group-item>
                      </PuSkeleton>
                  </b-list-group>
              </b-tab>
      </b-tabs>
     <b-tabs class="block__tabsSidebar" v-else>
        <div>
            <div class="entete">
                <div class="title">Agents</div>
            </div>
            <b-list-group>
                <PuSkeleton :loading="isListLoading" :count="5" width='100%'>
                    <div v-for="(value,index) in theList" :key="index" :title="value.title">
                        <b-list-group-item v-for="(subList,f) in value.ranking" :key="f" :class="subList.active ? 'active-rank' : ''">
                            <div class="bt-list left">
                                <div class="target" :class="getTheIncrease(subList.rank,subList.previousRank)">
                                    {{getTheIncrease(subList.rank,subList.previousRank)!= 'equal' ? getTheEvolution(subList.rank,subList.previousRank):''}}
                                </div>
                                <div class="ranking">{{subList.rank}}</div>
                                <div class="fullname">{{subList.name}}</div>
                            </div>
                            <div class="right">
                                {{Math.round(subList.points).toLocaleString()}}
                            </div>
                        </b-list-group-item>
                    </div>
                </PuSkeleton>
            </b-list-group>
        </div>
    </b-tabs>
  </PuSkeleton>

</template>

<script>

import Utils from "../../Utils"
import { mapGetters } from 'vuex'
import ApiService from '../../../services/ApiService';
import ApiAuthenticationService from '../../../services/ApiAuthenticationService';
//
export default {
  name: "TabsSidebar",
  components:{ 
  },
    computed: {
      ...mapGetters([
        'getGeneral',
        'getChallengeSelected',
      ])
    },  
  props:{
    lists:{
      type:Object,
      default:()=>{}
    },
    selected:{
    }
  },
  data(){
    return { 
      content:"",
      isPositif:false,
      isLoading:true,
      isListLoading:true,
      theList:null,
      listSelected:null,
      listAgents:'',
      allTheList:false,
      currentType:''
    }
  },
   created (){
    this.currentType = ApiAuthenticationService.getCurrentUser().type;
    this.content = this.getGeneral;
    this.listSelected = this.selected;    
    this.getData().then(() => {
        this.isListLoading = false;
        this.isLoading = false;
    });
  },    
  methods : {
    async getData(all = false){
        if(this.listSelected){
            await ApiService.getConcoursApi().getExcursionRanking(ApiAuthenticationService.getCurrentUser().id,this.getChallengeSelected,this.listSelected,all).then((data) => {
                this.theList = data.data.ranking;
            });
        }
    },
    putTheRightClass (target){
      return Utils.getTheClass(target);
    },
    fetchAll (event){
        this.isListLoading = true;
        this.getData(event.target.checked).then(() => {
            this.isListLoading = false;
        });
    },
    getTheEvolution(rank, previousRank){
      return Utils.compare(rank,previousRank);
    },
    getTheIncrease(rank, previousRank){
      return Utils.getTheClassCompare(rank,previousRank);
    }
  },  
  watch : {
    'selected' : function (){
      this.listSelected = this.selected;
      this.isLoading = true;
      this.getData().then(() => {
          this.isLoading = false;
          this.isListLoading = false;
      });
    },   
  },  
}
</script>
